import { useMediaQuery } from "@/hooks";
import { useI18n } from "@/lib/i18n/i18n_provider";
import { CatalogUpsellTextAlign } from "@/data/catalog";
import React from "react";
import { Button } from "react-bootstrap";
import classNames from "classnames";

interface HeroOverlayProps {
  title: string;
  description: string;
  imageUrl: string;
  longDescription?: string;
  buttonLabel?: string;
  onClickButton?: React.MouseEventHandler<HTMLButtonElement>;
  buttonUrl?: string;
  textAlign?: CatalogUpsellTextAlign;
}

export function HeroOverlay(props: HeroOverlayProps) {
  const {
    title,
    description,
    imageUrl,
    longDescription,
    buttonLabel,
    onClickButton,
    buttonUrl,
    textAlign,
  } = props;
  const { device } = useMediaQuery();
  const { fbt } = useI18n();

  return (
    <div
      style={{
        backgroundImage:
          device === "mobile"
            ? `linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.55)), url(${imageUrl})`
            : `linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 72.66%), url(${imageUrl})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        textAlign,
      }}
      className={classNames(
        "rounded text-white d-flex",
        textAlign === "center" && "justify-content-center text-center",
        textAlign === "end" && "justify-content-end text-end"
      )}
    >
      <div
        style={{
          maxWidth: device === "mobile" ? "100%" : "60%",
          padding: device === "mobile" ? "40px 16px" : "100px 40px",
        }}
      >
        <h1 className="text-white">{title}</h1>
        <div className="text-white">
          {longDescription ? (
            <div dangerouslySetInnerHTML={{ __html: longDescription }} />
          ) : (
            <div>{description}</div>
          )}
        </div>
        {!!buttonUrl?.length && (
          <a href={buttonUrl} target="_blank" rel="noopener noreferrer">
            <Button variant="primary" className="mt-3" onClick={onClickButton}>
              {buttonLabel || fbt("Learn more")}
            </Button>
          </a>
        )}
      </div>
    </div>
  );
}
